if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }

      // Bind buy now button
      this.buyNowButton = this.querySelector('.js-buy-now');
      if (this.buyNowButton) {
        this.buyNowButton.addEventListener('click', this.handleBuyNow.bind(this));
      }

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          if (document.body.classList.contains('is-show-sticky-atc-panel')) {
            this.adjustThirdPartyWidgets(true);
          }
        });
        this.resizeObserver.observe(this);
      }
    }

    adjustThirdPartyWidgets(isShown) {
      if (typeof window.adjustThirdPartyWidgets === 'function') {
        window.adjustThirdPartyWidgets(isShown);
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      if (this.widgetInterval) {
        clearInterval(this.widgetInterval);
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            const isShown = !(entry.boundingClientRect.bottom > 0);
            this.classList.toggle('sticky-atc-panel--out', !isShown);
            document.body.classList.toggle('is-show-sticky-atc-panel', isShown);
            this.adjustThirdPartyWidgets(isShown);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            const isShown = !entry.isIntersecting;
            this.classList.toggle('sticky-atc-panel--out', !isShown);
            document.body.classList.toggle('is-show-sticky-atc-panel', isShown);
            this.adjustThirdPartyWidgets(isShown);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);

      // Periodically check for 3rd party widgets if they load late
      let checkCount = 0;
      this.widgetInterval = setInterval(() => {
        checkCount++;
        const accessWidget = document.querySelector('access-widget-ui');
        const cookieConsent = document.querySelector('csm-cookie-consent');
        
        if (accessWidget || cookieConsent) {
          const isShown = document.body.classList.contains('is-show-sticky-atc-panel');
          this.adjustThirdPartyWidgets(isShown);
        }

        if (checkCount > 20) {
          clearInterval(this.widgetInterval);
        }
      }, 500);
    }

    /**
     * Handle buy now button click
     */
    async handleBuyNow(event) {
      const button = event.currentTarget;
      const variantId = button.dataset.variantId;

      if (!variantId || button.disabled) return;

      // Set loading state
      const originalText = button.textContent;
      button.disabled = true;
      button.classList.add('loading');
      button.textContent = 'Processing...';

      try {
        // Add to cart using Shopify AJAX API
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        // Redirect to checkout
        window.location.href = '/checkout';
      } catch (error) {
        console.error('Buy now error:', error);
        
        // Reset button state
        button.disabled = false;
        button.classList.remove('loading');
        button.textContent = originalText;
        
        // Show error message
        alert('Unable to process buy now. Please try again.');
      }
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
